import L from "leaflet";

export class DynamicUrlTileLayer extends L.TileLayer {
  constructor(
    baseUrl: string,
    options?: L.TileLayerOptions & {
      getDynamicUrl: (coords: { x: number; y: number; z: number }) => string;
    }
  ) {
    super(baseUrl, options);
    if (options?.getDynamicUrl) {
      this.getTileUrl = options.getDynamicUrl;
    }
  }
}
